import {createAction} from "redux-actions";

export const requestFeedsAction = createAction('FETCH_FEEDS');
export const receiveFeedsAction = createAction('RECEIVE_FEEDS');
export const clearFeedsAction = createAction('CLEAR_FEEDS');



// WEBPACK FOOTER //
// ./app/client/activityFeeds/actions.ts